import { useSort } from 'libs/searchspring/hooks/useSort'
import { FilterCollapse } from 'libs/searchspring/components/collection/filters/FilterCollapse'

export function SortItem() {
  const { sorts, activeSort, handleSort, resetSort } = useSort()

  const activeSortLabel = activeSort ? sorts.find((sort) => sort.value === activeSort)?.label : 'Recommended'

  return (
    <FilterCollapse label="Sort" activeFilterLabel={activeSortLabel} valueType="default">
      <div className="flex flex-col gap-y-1.5 px-margin pb-1.875 pt-0.875 md:px-1.5">
        <div className="flex w-fit cursor-pointer items-center gap-x-0.5">
          <input
            id={'sort__default'}
            className="field-radio"
            type="radio"
            value="default"
            name="sort"
            onClick={() => resetSort()}
            checked={!activeSort}
            aria-label="Recommended"
          />
          <label for={'sort__default'} className="paragraph-b cursor-pointer">
            Recommended
          </label>
        </div>
        {sorts?.map((sort) => (
          <div className="flex w-fit cursor-pointer items-center gap-x-0.5" key={sort.value}>
            <input
              id={`sort__${sort.value}`}
              className="field-radio"
              type="radio"
              value={sort.value}
              name="sort"
              onClick={() => handleSort(sort.value)}
              checked={activeSort === sort.value}
              aria-label={sort.label}
            />
            <label for={`sort__${sort.value}`} className="paragraph-b cursor-pointer">
              {sort.label}
            </label>
          </div>
        ))}
      </div>
    </FilterCollapse>
  )
}
